import axiosConfig from '../axiosConfig';

export type TErrorLog = {
	id: number;
	data: string;
	create_date: number;
	origin: string;
};

export class ErrorLog implements TErrorLog {
	id: number;
	data: string;
	create_date: number;
	origin: string;

	public static Default(): TErrorLog {
		return {
			id: 0,
			data: '',
			create_date: 0,
			origin: '',
		};
	}

	constructor(entity: TErrorLog) {
		this.id = entity.id;
		this.data = entity.data;
		this.create_date = entity.create_date;
		this.origin = entity.origin;
	}

	public static GetAll(expand: (keyof TErrorLog)[] = []): Promise<TErrorLog[]> {
		return axiosConfig.instance
			.get('admin/error-logs', { params: { expand: expand } })
			.then((res) => {
				return (res.data as TErrorLog[]).map((entity: TErrorLog) => {
					return entity;
				});
			});
	}
}
